import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Contact from '../views/Contact.vue'
import Showroom from '../views/showroom/Showroom.vue'
import ShowroomTwo from '../views/showroom/ShowroomTwo.vue'
import ShowroomThree from '../views/showroom/ShowroomThree.vue'
import ShowroomFour from '../views/showroom/ShowroomFour.vue'
import EmailSent from '../views/EmailSent.vue'
import Privacy from '../views/Privacy.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'NG Construction | Home'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: 'NG Construction | Contact'
    }
  },
  {
    path: '/showroom',
    name: 'Showroom',
    component: Showroom,
    meta: {
      title: 'NG Construction | Showroom'
    }
  },
  {
    path: '/showroomTwo',
    name: 'ShowroomTwo',
    component: ShowroomTwo,
    meta: {
      title: 'NG Construction | Showroom'
    }
  },
  {
    path: '/showroomThree',
    name: 'ShowroomThree',
    component: ShowroomThree,
    meta: {
      title: 'NG Construction | Showroom'
    }
  },
  {
    path: '/showroomFour',
    name: 'ShowroomFour',
    component: ShowroomFour,
    meta: {
      title: 'NG Construction | Showroom'
    }
  },
  {
    path: '/emailSent',
    name: 'EmailSent',
    component: EmailSent,
    meta: {
      title: 'NG Construction | EmailSent'
    }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
    meta: {
      title: 'NG Construction | Privacy'
    }
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router
